import { markdownItReplacePlugin, markdownItSplit } from "./utils";
import markdownItContainer from '@kangc/v-md-editor/lib/utils/markdown-it-container';

export default class PropsPlugin {

  __name__ = 'props';
  __text__ = 'Props';
  __icon__ = '';
  __toolbar__ = '';

  __propConig__ = [];
  __propValues__ = {};
  __propPrefix__ = '::';
  __propSuffix__ = '::';
  __ifPlaceholder__ = '输入条件参数';
  __ifToolbar__ = 'IF 条件';
  __ifPrefix__ = '<<< if';
  __ifSuffix__ = '<<<';

  __editor__ = null;

  __replaceContent(content, flag) {
    return markdownItSplit(content, this.__propPrefix__, this.__propSuffix__).filter(item => item.value).map(item => {
      if (item.type == 'match') {
        return this.__value(item.value, flag ? item.value : '');
      }
      return item.value;
    }).join("");
  }

  __splitToken(content, Token) {
    let replacedContent = this.__replaceContent(content, content);
    var token = new Token('text', '', 0);
    token.content = replacedContent;
    return [token];
  }

  __value(name, def) {
    return this.__propValues__[name] || def;
  }

  __insert(content, selected, tag) {
    if (tag === this.__ifPrefix__) {
      return `${this.__ifPrefix__} ${this.__ifPlaceholder__}\n${selected || ''}\n\n<<<`
    }
    return `${this.__propPrefix__}${content}${this.__propSuffix__}`
  }

  __selected(content, selected, tag) {
    if (tag === this.__ifPrefix__) {
      return `${this.__ifPlaceholder__}`
    }
    return `${this.__propPrefix__}${content}${this.__propSuffix__}`
  }

  __init() {
    if (this.__editor__) {
      if (this.__editor__.name === 'v-md-editor') {
        this.__editor__.command(this.__name__, (editor, type = 'name', tag = '') => {
          editor.insert((selected) => {
            const content = type;
            return {
              text: this.__insert(content, selected, tag),
              selected: this.__selected(content, selected, tag),
            };
          });
        });
        this.__editor__.toolbar(this.__name__, {
          icon: this.__icon__,
          title: this.__toolbar__ || this.__name__,
          text: !!this.__icon__ ? '' : (this.__text__ || this.__name__),
          menus: [
            {
              name: `prop_if`,
              text: (editor) => `${this.__ifToolbar__}`,
              action: (editor) => {
                editor.execCommand(this.__name__, '', this.__ifPrefix__);
              },
            },
            ...this.__propConig__.map(item => {
              return {
                name: `prop_value_${item.name}`,
                text: (editor) => item.label || item.name,
                action: (editor) => {
                  editor.execCommand(this.__name__, item.name);
                },
              }
            }),
          ],
        });
      }
      this.__editor__.extendMarkdown((mdParser) => {
        if (mdParser) {
          mdParser.use(markdownItReplacePlugin, {
            pluginName: `v-md-plugin-${this.__name__}`,
            replaceToken: (content, Token) => {
              return this.__splitToken(content, Token);
            },
            replaceAttrs: (attrs) => {
              return (attrs || []).map(attr => {
                let replacedAttr = this.__replaceContent(decodeURIComponent(attr[1]));
                return [attr[0], replacedAttr]
              })
            }
          });
        }
      });
      this.__editor__.extendMarkdown((mdParser) => {
        if (mdParser) {
          mdParser.use(markdownItContainer, {
            type: 'if',
            marker: "<",
            defaultTitle: () => "",
            before: (info) => {
              let flag = this.__replaceContent(info, false);
              if (flag) {
                return `<div class="display: block;">\n`;
              }
              return `<div style="display: none;">\n`
            },
            after: () => '</div>\n',
          });
        }
      });
    }
  }

  isEnable() {
    return this.__propConig__.length > 0;
  }

  setInfo(text, icon, toolbar) {
    this.__icon__ = icon || this.__icon__;
    this.__text__ = text || this.__text__;
    this.__toolbar__ = toolbar || this.__toolbar__;
  }

  setProps(props = [], propValues = {}) {
    this.__propValues__ = propValues;
    this.__propConig__ = props;
    this.__init();
  }

  install(editor) {
    this.__editor__ = editor;
    this.__init();
  }

}